import _ from "lodash";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    video: _.get(data, "desktop_video"),
    imageBanner: _.get(data, "media_desktop_image_data.full_file_path"),
    imageBannerMobile: _.get(data, "media_mobile_image_data.full_file_path")
  };
};

const fetchEventPageApi = () => {
  return fetchApi("page/event")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchEventPageApi };



// WEBPACK FOOTER //
// ./src/services/page/eventpage.js